import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Building2, Users, MapPin } from "lucide-react";

interface Branch {
  nursery_id: string;
  name: string;
  children_count: number;
  price_per_child: number;
  total: number;
  is_parent: boolean;
}

interface Props {
  branches: Branch[];
  grandTotal: number;
  totalChildren: number;
  minChargeApplied?: boolean;
  minCharge?: number;
}

const BranchBillingBreakdown = ({ branches, grandTotal, totalChildren, minChargeApplied, minCharge }: Props) => {
  if (!branches || branches.length <= 1) return null;

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-lg">
          <Building2 className="w-5 h-5" />
          تفصيل الفروع
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {branches.map((branch) => (
          <div
            key={branch.nursery_id}
            className="flex items-center justify-between p-3 rounded-lg border bg-muted/20"
          >
            <div className="flex items-center gap-2">
              <MapPin className="w-4 h-4 text-muted-foreground" />
              <div>
                <span className="font-medium">{branch.name}</span>
                {branch.is_parent && (
                  <Badge variant="secondary" className="mr-2 text-xs">الرئيسي</Badge>
                )}
              </div>
            </div>
            <div className="flex items-center gap-4 text-sm">
              <span className="flex items-center gap-1 text-muted-foreground">
                <Users className="w-3.5 h-3.5" />
                {branch.children_count} طفل
              </span>
              <span className="text-muted-foreground">× {branch.price_per_child} ج.م</span>
              <span className="font-bold min-w-[80px] text-left">{branch.total.toLocaleString()} ج.م</span>
            </div>
          </div>
        ))}

        {/* Total */}
        <div className="flex items-center justify-between pt-3 border-t font-bold">
          <span>الإجمالي ({totalChildren} طفل)</span>
          <span className="text-lg">{grandTotal.toLocaleString()} ج.م</span>
        </div>
        {minChargeApplied && minCharge && (
          <p className="text-xs text-amber-600 dark:text-amber-400">
            ⚠️ تم تطبيق الحد الأدنى ({minCharge.toLocaleString()} ج.م)
          </p>
        )}
      </CardContent>
    </Card>
  );
};

export default BranchBillingBreakdown;
